import { Box, Grid, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import IButton from '../../../components/button/i-button.component';

const EditCellComponent = (props: any) => {
  const [cellValue, setCellValue] = useState(null);

  useEffect(() => {
    let value;
    if (props.label === 'Unit Cost') {
      value = null === cellValue ? props.data.unitCost : cellValue;
    } else if (props.label === 'Output Quantity') {
      value = null === cellValue ? props.data.output : cellValue;
    } else if (props.label === 'Order Quantity') {
      value = null === cellValue ? props.data.quantity : cellValue;
    } else if (props.label === 'Process Loss') {
      value = null === cellValue ? props.data.processLossPercentage : cellValue;
    } else if (props.label === 'PO Value') {
      value = null === cellValue ? props.data.poValue : cellValue;
    } else if (props.label === 'Pc/Pack') {
      value = null === cellValue ? props.data.pack : cellValue;
    } else if (props.label === 'Unit Count') {
      value = null === cellValue ? props.data.unitCount : cellValue;
    } else if (props.label === 'Product Cost') {
      value = null === cellValue ? props.data.prdCost : cellValue;
    } else if (props.label === 'Product Price') {
      value = null === cellValue ? props.data.price : cellValue;
    } else if (props.label === 'Ad Spend') {
      value = null === cellValue ? props.data.adSpend : cellValue;
    } else if (props.label === 'Click') {
      value = null === cellValue ? props.data.click : cellValue;
    } else if (props.label === 'CTR') {
      value = null === cellValue ? props.data.ctr : cellValue;
    } else if (props.label === 'Canada Sale') {
      value = null === cellValue ? props.data.canadaSale : cellValue;
    } else if (props.label === 'Mexico Sale') {
      value = null === cellValue ? props.data.mexicoSale : cellValue;
    } else if (props.label === 'Unit Sale Price') {
      value = null === cellValue ? props.data.unitSalePrice : cellValue;
    } else if (props.label === 'Fulfillment Fee') {
      value = null === cellValue ? props.data.fulfillmentFee : cellValue;
    } else if (props.label === 'Referral Fee') {
      value = null === cellValue ? props.data.referralFee : cellValue;
    } else if (props.label === 'Quantity') {
      value = null === cellValue ? props.data.quantity : cellValue;
    } else if (props.label === 'Sale') {
      value = null === cellValue ? props.data.sale : cellValue;
    } else if (props.label === 'Refund') {
      value = null === cellValue ? props.data.refund : cellValue;
    } else if (props.label === 'LFH Cost') {
      value = null === cellValue ? props.data.lfhCost : cellValue;
    } else if (props.label === 'Other Gain') {
      value = null === cellValue ? props.data.othGain : cellValue;
    } else if (props.label === 'Consumption') {
      value = null === cellValue ? props.data.consumption : cellValue;
    } else if (props.label === 'Planned Input') {
      value = null === cellValue ? props.data.plannedInput : cellValue;
    }

    setCellValue(value);
  });
 
  const onOk = () => {
    if (props.label === 'Unit Cost') {
      props.data.unitCost = cellValue;
    } else if (props.label === 'Output Quantity') {
      props.data.output = cellValue;
    } else if (props.label === 'Order Quantity') {
      props.data.quantity = cellValue;
    } else if (props.label === 'Process Loss') {
      props.data.processLossPercentage = cellValue;
    } else if (props.label === 'PO Value') {
      props.data.poValue = cellValue;
    } else if (props.label === 'Pc/Pack') {
      props.data.pack = cellValue;
    } else if (props.label === 'Unit Count') {
      props.data.unitCount = cellValue;
    } else if (props.label === 'Product Cost') {
      props.data.prdCost = cellValue;
    } else if (props.label === 'Product Price') {
      props.data.price = cellValue;
    } else if (props.label === 'Ad Spend') {
      props.data.adSpend = cellValue;
    } else if (props.label === 'Click') {
      props.data.click = cellValue;
    } else if (props.label === 'CTR') {
      props.data.ctr = cellValue;
    } else if (props.label === 'Canada Sale') {
      props.data.canadaSale = cellValue;
    } else if (props.label === 'Mexico Sale') {
      props.data.mexicoSale = cellValue;
    } else if (props.label === 'Unit Sale Price') {
      props.data.unitSalePrice = cellValue;
    } else if (props.label === 'Fulfillment Fee') {
      props.data.fulfillmentFee = cellValue;
    } else if (props.label === 'Referral Fee') {
      props.data.referralFee = cellValue;
    } else if (props.label === 'Quantity') {
      props.data.quantity = cellValue;
    } else if (props.label === 'Sale') {
      props.data.sale = cellValue;
    } else if (props.label === 'Refund') {
      props.data.refund = cellValue;
    } else if (props.label === 'LFH Cost') {
      props.data.lfhCost = cellValue;
    } else if (props.label === 'Other Gain') {
      props.data.othGain = cellValue;
    } else if (props.label === 'Consumption') {
      props.data.consumption = cellValue;
    } else if (props.label === 'Planned Input') {
      props.data.plannedInput = cellValue;
    }
    
    props.close('Ok');
  }

  const onCancel = () => {
    props.close('Cancel');
  }

  const updateCellValue = (e: any) => {
    setCellValue(e.target.value);
  }

  const getMainComponent = () => {
    return <Grid container spacing={0}>
      <Grid xs={12}>
        <TextField InputLabelProps={{ shrink: true }} name='cellValue' label={props.label} type='number' value={cellValue} margin='dense' 
          inputProps={{ style: { height: "9px"}}} onChange={updateCellValue} size='medium' fullWidth={true}/>
      </Grid>
      <Box display="flex" justifyContent="center" width="100%" mt={2}>
        <IButton name='submit' label='Submit' color="primary" onActionEvent={onOk}/>
        <IButton name='cancel' label='Cancel' color="secondary" onActionEvent={onCancel}/>
      </Box>
    </Grid>
  }

  return getMainComponent()
}

export default EditCellComponent;